
const NotificationFactoryClass = require('./notification.factory.class');
// import { RecommendationBuy, RecommendationFixedIncome } from './notification.factory.class';

export class NotificationFactory {
    constructor(notificationObj: any) {
        let _class = NotificationFactoryClass[notificationObj.type];
        return new _class(notificationObj);
    }
}